/**
 * Single source of truth for FAQ categories rendered on the FAQ page.
 * `translationKey` matches the `faq.<translationKey>.*` keys in locale files.
 * `id` is used for anchors / quick-nav jump links.
 */
export const FAQ_CATEGORIES = [
    { id: 'getting-started', translationKey: 'gettingStarted', icon: '🚀', questionKeys: ['1', '2', '3'] },
    { id: 'invoices', translationKey: 'invoices', icon: '🧾', questionKeys: ['1', '2', '3', '4', '5'] },
    { id: 'estimates', translationKey: 'estimates', icon: '📋', questionKeys: ['1', '2', '3'] },
    { id: 'payments', translationKey: 'payments', icon: '💳', questionKeys: ['1', '2', '3', '4'] },
    { id: 'payment-reminders', translationKey: 'paymentReminders', icon: '⏰', questionKeys: ['1', '2'] },
    { id: 'clients-expenses', translationKey: 'clientsAndExpenses', icon: '👥', questionKeys: ['1', '2'] },
    { id: 'time-tracking', translationKey: 'timeTracking', icon: '⏱️', questionKeys: ['1', '2'] },
    { id: 'ai-estimator', translationKey: 'aiEstimator', icon: '✨', questionKeys: ['1', '2'] },
    { id: 'reports', translationKey: 'businessReports', icon: '📊', questionKeys: ['1', '2', '3'] },
    { id: 'billing', translationKey: 'billing', icon: '💰', questionKeys: ['1', '2', '3'] },
    { id: 'security', translationKey: 'security', icon: '🔒', questionKeys: ['1', '2'] },
    { id: 'mobile', translationKey: 'mobile', icon: '📱', questionKeys: ['1', '2'] }
];
